import { render, staticRenderFns } from "./UserDataForm.vue?vue&type=template&id=c0b74330&"
import script from "./UserDataForm.vue?vue&type=script&lang=js&"
export * from "./UserDataForm.vue?vue&type=script&lang=js&"
import style0 from "./UserDataForm.vue?vue&type=style&index=0&id=c0b74330&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports